export default __webpack_public_path__ + "static/media/confetti-4.c1c90361.gif";